export default __webpack_public_path__ + "static/media/property_646.cfa64bee.png";